import AppHeader from "@/components/AppHeader";

export default {
  name: "master-department",
  components: {
    AppHeader
  },
  async created() {
    await this.getCompany();
    await this.getDepartment();
  },
  data() {
    return {
      companies: "",
      departments: [],
      selectedCompany: localStorage.company_id,
      getCompanisEnd: false,
      getDepartmentsEnd: false
    };
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    },
    async getDepartment() {
      this.getDepartmentsEnd = false;
      let data = {
        company_id: this.selectedCompany
      };
      let res = await this.$store
        .dispatch("GET_DEPARTMENT", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.departments = res.departments;
      this.getDepartmentsEnd = true;
    },
    goDepartmentEdit(departmentId) {
      this.$router.push({ path: `/master_department/${departmentId}/edit` });
    },
    deleteModal(departmentId) {
      this.deleteDepartmentId = departmentId;
      this.$bvModal.show("modal-delete");
    },
    async deleteDepartment() {
      let res = await this.$store
        .dispatch("DELETE_DEPARTMENT", {
          id: this.deleteDepartmentId,
          data: {}
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (!res.error) {
        this.getDepartment();
      }
      this.$bvModal.hide("modal-delete");
    }
  }
};
